import { render } from "./QimenStrategy.vue?vue&type=template&id=4d95ee62&scoped=true"
import script from "./QimenStrategy.vue?vue&type=script&lang=js"
export * from "./QimenStrategy.vue?vue&type=script&lang=js"

import "./QimenStrategy.vue?vue&type=style&index=0&id=4d95ee62&scoped=true&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d95ee62"]])

export default __exports__